<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <b-tabs
            justified
            nav-class="nav-tabs-custom"
            content-class="p-3 text-muted"
          >
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">
                  {{ $t("advanced.checker") }}</span
                >
              </template>
              <div class="row">
                <div class="col-12" style="min-height: 50vh">
                  <div class="media">
                    <div class="avatar-sm mr-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-light
                          text-primary
                          border-primary
                          font-size-22
                        "
                      >
                        <i class="bx bx-search bx-md"></i>
                      </span>
                    </div>
                    <div class="media-body">
                      <h5 class="mt-3">
                        {{ $t("advanced.exposed-credential") }}
                      </h5>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-sm-12 text-right">
                      <div class="input-group">
                        <input
                          id="search"
                          type="text"
                          class="form-control"
                          v-model="searchKey"
                          placeholder="email.."
                          aria-describedby="search"
                          @keyup.enter="searchEmail"
                        />
                        <div class="input-group-prepend">
                          <button
                            id="search"
                            class="input-group-text bg-primary text-white"
                            @click="searchEmail"
                          >
                            <i class="bx bx-search-alt search-icon"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="loading.search" class="row mt-4 mx-auto">
                    <div class="col-12">
                      <div class="text-center mt-4">
                        <div
                          class="spinner-border text-secondary mb-2"
                          role="status"
                        ></div>
                        <p class="bx-flashing mt-1">
                          {{ $t("advanced.getting") }} . . .
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row mt-4">
                      <div
                        class="col-12 mb-4"
                        v-if="exposed.length != 0 && exposed[0].profile"
                      >
                        <span>Related Target</span>
                        <div class="d-flex">
                          <div
                            class="social-source text-center mt-3 mx-2 px-2"
                            v-for="(tr, idx) in exposed[0].profile"
                            :key="idx"
                          >
                            <div class="avatar-sm mx-auto mb-3">
                              <img
                                :src="urlimage + tr.image_project"
                                class="rounded-circle avatar-sm m-1"
                                alt
                              />
                            </div>
                            <p class="text-muted mb-0">
                              {{ tr.title }}
                            </p>
                          </div>
                        </div>
                        <hr />
                      </div>
                      <div class="col-12 mb-2" v-if="exposed != 0">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          {{ $t("advanced.result-found") }}
                          {{ exposed.length }} {{ $t("advanced.from-breach") }}
                          <div>
                            <b-button
                              variant="success"
                              class="btn-sm"
                              @click="openToAdd"
                            >
                              <span v-if="loading.saveall">
                                <i class="mdi mdi-loading mdi-spin"></i>
                                {{ $t("advanced.saving") }}
                              </span>
                              <span v-else>
                                {{ $t("advanced.save-to-target") }}</span
                              >
                            </b-button>
                          </div>
                        </div>
                        <!-- <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                          v-else
                        >
                           {{ $t("advanced.result-found") }} {{ exposed.length }}  {{ $t("advanced.from-store") }}
                          <div>
                            <b-button variant="primary" @click="saveAll">
                                    <span v-if="loading.saveall">
                                        <i class="mdi mdi-loading mdi-spin"></i> Saving
                                    </span>
                                    <span v-else>
                                        Save 
                                    </span>
                                </b-button>
                          </div>
                        </div> -->
                      </div>

                      <div
                        v-for="(e, index) in exposed"
                        :key="index"
                        class="col-sm-3 py-2"
                      >
                        <div
                          class="
                            d-block
                            border border-primary
                            rounded
                            p-2
                            h-100
                          "
                        >
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <h5 class="text-truncate">{{ e.source }}</h5>
                            <i
                              v-if="!e.has_password"
                              class="bx bxs-lock bx-sm"
                            ></i>
                            <i
                              v-if="e.has_password"
                              class="text-success bx bxs-lock-open bx-sm"
                            ></i>
                          </div>
                          <hr />
                          <div class="text-xs">
                            <small v-if="e.has_password"
                              >Password : {{ e.password }}</small
                            ><br />
                            <small v-if="e.has_password"
                              >Password Hash : {{ e.hash }}</small
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 text-center"
                        v-if="
                          dnf &&
                          !loading.search &&
                          exposed.length < 1 &&
                          error == ''
                        "
                      >
                        <p class="text-secondary p-5">
                          {{ $t("overview.table.all.dnf") }}
                        </p>
                      </div>

                      <div
                        v-if="error !== '' && !loading.search"
                        class="row mt-5 mb-5 pb-4 mx-auto"
                      >
                        <div class="text-center">
                          <span class="text-secondary">{{ error }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-user"></i>
                </span>
                <span class="d-none d-sm-inline-block">{{
                  $t("advanced.database")
                }}</span>
              </template>
              <div class="media">
                <div class="avatar-sm mr-3">
                  <span
                    class="
                      avatar-title
                      rounded-circle
                      bg-light
                      text-primary
                      border-primary
                      font-size-22
                    "
                  >
                    <i class="bx bx-data bx-md"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h5 class="mt-3">
                    {{ this.$t("advanced.exposed-credential") }}
                  </h5>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-12" style="min-height: 50vh">
                  <b-table
                    :items="tableData"
                    :fields="fields"
                    bordered
                    striped
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                  >
                    <template #cell(profile)="row">
                      <div class="d-flex">
                        <div
                          v-for="(pr, index) in row.item.profile"
                          :key="index"
                        >
                          <div class="text-center mx-2">
                            <img
                              :title="pr.title"
                              :src="urlimage + pr.image_project"
                              class="rounded-circle avatar-xs m-1"
                              alt
                            />
                            <br />
                            <span>{{ pr.title }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(actions)="row">
                      <router-link
                        :to="{
                          name: 'detail-credential',
                          params: { email: row.item.email },
                        }"
                      >
                        <b-button class="mr-1 btn-sm" variant="primary">
                          <i class="fas fa-info"></i>
                          Detail
                        </b-button>
                      </router-link>
                      <b-button
                        class="mr-1 btn-sm"
                        variant="danger"
                        @click="deleteDataBreach(row.item.id_target)"
                      >
                        <i class="bx bx-trash"></i>
                        {{ $t("button.hapus.text") }}
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      hide-footer
      :id="'add-to-target'"
      centered
      :title="'Add to project'"
      title-class="font-18"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      {{ $t("all.show") }}&nbsp;&nbsp;
                      <b-form-select
                        v-model="target.perPage"
                        size="sm"
                        :options="target.pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="target.filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="target.tableData"
                  :fields="target.fields"
                  bordered
                  responsive="sm"
                  :per-page="target.perPage"
                  :current-page="target.currentPage"
                  :sort-by.sync="target.sortBy"
                  :sort-desc.sync="target.sortDesc"
                  :filter="target.filter"
                  :filter-included-fields="target.filterOn"
                  @filtered="onFilteredTarget"
                  show-empty
                >
                  <template #empty>
                    <h6 class="text-center" v-if="!loading.target">
                      {{ $t("table.empty-text") }}
                    </h6>
                    <h6 class="text-center" v-if="loading.target">
                      <i class="bx bx-loader bx-spin bx-md"></i>
                    </h6>
                  </template>
                  <template #cell(target)="row">
                    <div class="col-sm-12">
                      <div class="media">
                        <img
                          :src="urlimage + row.item.image_project"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <b> {{ row.item.title }}</b> <br />
                          <p class="text-secondary">
                            {{ $t("all.updated") }} :
                            {{ formatDate(row.item.updated_at) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button
                      class="mr-2 btn-sm"
                      @click="addToTarget(row.item.id_target)"
                      variant="primary"
                    >
                      <span
                        v-if="
                          (!loading.add.status &&
                            loading.add.id != row.item.id_target) ||
                          loading.add.id != row.item.id_target
                        "
                      >
                        <i class="bx bx-plus"></i> {{ $t("advanced.add") }}
                      </span>
                      <span
                        v-if="
                          loading.add.status &&
                          loading.add.id == row.item.id_target
                        "
                      >
                        <i class="bx bx-loader bx-spin"></i> process
                      </span>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="target.currentPage"
                        :total-rows="rows_target"
                        :per-page="target.perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import AdvancedService from "@/helpers/advanced.service";
import BreachService from "@/helpers/breach.service";
import PreferenceService from "@/helpers/preference.service.js";
import TargetService from "@/helpers/target-profile.service";
import Swal from "sweetalert2";
import appConfig from "@/app.config";
import moment from "moment";
import Vue from "vue";
import axios from "axios";

export default {
  page: {
    title: "Exposed Credential",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("advanced.exposed-credential"),
          active: true,
        },
      ],
      loading: {
        search: false,
        saveall: false,
        target: false,
        search: false,
        add: {
          id: "",
          status: false,
        },
        update: {
          id: "",
          status: false,
        },
      },
      temp_data: "",
      urlimage: process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "email",
      sortDesc: false,
      error: "",
      pref: "",
      api_host: "",
      x_rapidapi_host: "",
      x_rapidapi_key: "",
      fields: [
        {
          key: "email",
          sortable: true,
          label: "Email",
          thStyle: { width: "30%" },
        },
        {
          key: "totaldata",
          sortable: true,
          class: "text-center",
          label: "Total Data",
          thStyle: { width: "20%" },
        },
        {
          key: "profile",
          sortable: true,
          label: "Related Target",
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("table.open-cctv.th.action"),
          thStyle: { width: "20%" },
        },
      ],
      target: {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: false,
        fields: [
          { key: "target", label: "Target", sortable: true },
          { key: "description", label: "Description", sortable: true },
          { key: "category", label: "Category", sortable: true },
          {
            key: "actions",
            label: this.$t("table.citizen.th.action"),
            class: "text-center",
          },
        ],
      },
      searchKey: "",
      searchSource: "",
      dnf: false,
      email: "",
      exposed: [],
      title: this.$t("advanced.exposed-credential"),
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rows_target() {
      return this.target.tableData.length;
    },
  },
  methods: {
    comingSoon() {
      alert("Coming Soon");
    },
    openToAdd(data) {
      this.loadTarget();
      this.$bvModal.show("add-to-target");
      this.temp_data = data;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onFilteredTarget(filteredItems) {
      this.target.totalRows = filteredItems.length;
      this.target.currentPage = 1;
    },

    loadTarget() {
      this.loading.target = true;
      this.target.tableData = [];
      TargetService.getTargetBy()
        .then((response) => {
          response.data.data.forEach((element) => {
            const data = {
              id_target: element.id_target,
              title: element.title,
              image_project: element.image_project,
              description: element.description,
              category: element.category.category_name,
              updated_at: element.updated_at,
            };
            this.target.tableData.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading.target = false;
        });
    },

    searchEmail() {
      if (this.searchKey != "") {
        this.exposed = [];
        this.email = this.searchKey;
        this.loading.search = true;
        this.getLocalData();
      }
    },

    getPreferences() {
      let id = 3;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log('pref api =>', response);
          this.pref = response.data.data;
          this.api_host = response.data.data.api_host;
          this.x_rapidapi_host = response.data.data.api_header_host;
          this.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getRapid() {
      this.error = "";
      const options = {
        method: "GET",
        url: this.api_host,
        params: { func: "auto", term: this.email },
        headers: {
          "content-type": "application/json",
          "x-rapidapi-host": this.x_rapidapi_host,
          "x-rapidapi-key": this.x_rapidapi_key,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.success) {
            // console.log("rapid found");
            response.data.result.forEach((el) => {
              this.exposed.push({
                email: this.email,
                has_password: el.has_password,
                password: el.password ?? "",
                hash: el.hash ?? "",
                source: el.sources[0].length > 1 ? el.sources[0] : el.sources,
              });
            });
            // console.log("save rapid result");
            this.loading.search = false;
          } else {
            console.log("rapid not found");
            this.dnf = true;
            this.loading.search = false;
          }
        })
        .catch((err) => {
          console.log("rapid error", err.response.status);
          this.dnf = true;
          this.loading.search = false;
          if (err.response.status == 500) {
            this.error = "Internal server Error";
          } else if (err.response.status == 404) {
            this.error = "Server Not Found";
          } else if (err.response.status == 403) {
            this.error = "Forbidden";
          }
        });
    },
    getLocalData() {
      BreachService.getBreach(this.email)
        .then((response) => {
          if (response.data.data == 0) {
            // console.log("local not found");
            this.searchSource = "rapid";
            this.getRapid();
            // console.log("change search to rapid");
          } else {
            console.log("local found", response);
            this.searchSource = "local";
            response.data.data.forEach((element) => {
              const mergeData = {
                ...element.breach,
                ...{ profile: element.profile },
              };

              this.exposed.push(mergeData);
            });
            this.loading.search = false;
            // console.log("save local result");
          }
        })
        .catch((err) => {
          console.log("local error");
          this.dnf = true;
          this.loading.search = false;
          console.log(err);
        });
    },
    getList() {
      BreachService.list()
        .then((response) => {
          response.data.data.forEach((element) => {
            const mergeData = {
              ...element.breach,
              ...{ profile: element.profile },
            };
            this.tableData.push(mergeData);
          });
          console.log("list ", this.tableData);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //    getList(){
    //     this.loading = true;
    //     TargetService.getTargetByNews()
    //     .then((response) => {
    //         // console.log( response.data.data);
    //         response.data.data.forEach(val => {
    //             const data = {
    //                 "id_target" : val.id_target,
    //                 "title" : val.title,
    //                 "image_project" : val.image_project,
    //                 "description" : val.description,
    //                 "category" : val.category.category_name,
    //                 "news" : val.news,
    //                 "updated_at" : val.updated_at
    //             }
    //             this.tableData.push(data);
    //             })

    //             this.loading = false;
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             this.loading = false;
    //         });
    //     },

    // saveAll() {
    //     console.log(this.exposed);
    //     this.loading.saveall = true;
    //     let data = {
    //         "data": this.exposed
    //     }
    //     BreachService.saveBreach(data)
    //     .then((response) => {
    //         console.log(response);
    //         this.loading.saveall = false;
    //         this.exposed = [];
    //     })
    //     .catch((err) => {
    //         this.loading.saveall = false;
    //         this.exposed = [];
    //         console.log(err);
    //     });
    // },

    addToTarget(id) {
      let data = {
        id_target: id,
        data: this.exposed,
      };
      // console.log(data);
      BreachService.saveBreach(data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$bvModal.hide("add-to-target");
          this.$router.push({ name: "project-overview", params: { id: id } });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteDataBreach(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          BreachService.deleteBreach(id)
            .then((response) => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
              this.getList();
            })
            .catch((err) => {
              console.log(err);
            });
          console.log("hapus:", id);
        }
      });
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },
  },
  mounted() {
    this.getList();
    this.getPreferences();
    this.loadTarget();
    this.totalRows = this.items.length;
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>
